export enum DayCareStatus {
  SCHEDULED = 'SCHEDULED',
  CHECKED_IN = 'CHECKED_IN',
  IN_PROCEDURE = 'IN_PROCEDURE',
  RECOVERY = 'RECOVERY',
  COMPLETED = 'COMPLETED',
  DISCHARGED = 'DISCHARGED',
  CANCELLED = 'CANCELLED',
}

export enum DayCareResourceType {
  OBSERVATION_BED = 'OBSERVATION_BED',
  PROCEDURE_ROOM = 'PROCEDURE_ROOM',
  DIALYSIS_MACHINE = 'DIALYSIS_MACHINE',
  RECLINER = 'RECLINER',
  ENDOSCOPY_SUITE = 'ENDOSCOPY_SUITE',
  OTHER = 'OTHER',
}

export interface DayCareProcedure {
  id: string;
  hospitalId: string;
  name: string;
  departmentId: string;
  defaultDurationMinutes?: number | null;
  baseCharge: number;
  isActive: boolean;
}

export interface DayCareResource {
  id: string;
  hospitalId: string;
  name: string;
  type: DayCareResourceType;
  departmentId: string;
  isActive: boolean;
}

export interface DayCareCaseListItem {
  id: string;
  dcNumber?: string | null;
  hospitalId: string;
  patientId: string;
  doctorId: string;
  departmentId: string;
  procedureId: string;
  status: DayCareStatus;
  scheduledAt: string;
  checkedInAt?: string | null;
  procedureStartAt?: string | null;
  procedureEndAt?: string | null;
  recoveryStartAt?: string | null;
  dischargedAt?: string | null;
  resourceId?: string | null;
  nurseId?: string | null;
  notes?: string | null;
  createdById?: string | null;
  appointmentId?: string | null;

  patient: {
    id: string;
    name: string;
    uhid: string | null;
    gender: 'MALE' | 'FEMALE' | 'OTHER';
    phone: string;
    dob: string;
  };
  doctor: {
    id: string;
    name: string;
    specialisation?: string | null;
  };
  nurse?: {
    id: string;
    name: string;
  } | null;
  procedure: DayCareProcedure;
  resource?: DayCareResource | null;
}

export interface CreateDayCareCasePayload {
  patientId: string;
  procedureId: string;
  doctorId?: string;
  departmentId?: string;
  scheduledAt?: string;
  resourceId?: string;
  nurseId?: string;
  notes?: string;
  /** When creating a case from "Add Appointment" (Visit Type = Day Care) */
  appointmentId?: string;
  salesPersonName?: string;
  partnerLeadName?: string;
  /** Stored on Patient (same as IPD admission) */
  referralPersonName?: string;
}

